import React from 'react';
import { styled } from '@mui/material/styles';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch, { SwitchProps } from '@mui/material/Switch';
import Stack from '@mui/material/Stack';


const AntSwitch = styled(Switch)(({ theme }) => ({
      width: 28,
      height: 16,
      padding: 0,
      display: 'flex',
      '&:active': {
        '& .MuiSwitch-thumb': {
          width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
          transform: 'translateX(9px)',
        },
      },
      '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
          transform: 'translateX(12px)',
          color: '#fff',
          '& + .MuiSwitch-track': {
            opacity: 1,
            backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#16dfad',
          },
        },
      },
      '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 12,
        height: 12,
        borderRadius: 6,
        transition: theme.transitions.create(['width'], {
          duration: 200,
        }),
      },
      '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor:
          theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
        boxSizing: 'border-box',
      },
  })); 

class MUI_Switch extends React.Component {
  constructor(props) {
    super(props);

}
  render(){
    return (
        <FormGroup>
          <Stack direction="row" spacing={1} alignItems="center">
              
              <p className='no_margin'>{this.props.left_label}</p>
              
              <AntSwitch 
                
                onChange={this.props.changeHandler}
                checked={this.props.checked}
                disabled={!!this.props.disabled}
                inputProps={{ 'aria-label': 'ant design' }} 
              />
              
              <p className='no_margin'>
              {this.props.right_label}
              </p>
  
          </Stack>
      </FormGroup>
  
    )
  }
    
}
export default MUI_Switch;